Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.fundamental?window.GrimoireJS.lib.fundamental.Resource.Texture2D:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-fundamental/ref/Resource/Texture2D.js
// module id = 26
// module chunks = 0